var map = {
	"./assets/thewest-digital-hero-cropped.jpg": 881,
	"./assets/thewest-digital-hero-variation-a-cropped.jpg": 882,
	"./assets/thewest-digital-hero-variation-a.jpg": 2956,
	"./assets/thewest-digital-hero-variation-b-cropped.jpg": 883,
	"./assets/thewest-digital-hero-variation-b.jpg": 2957,
	"./assets/thewest-digital-hero-variation-black-friday-cropped.jpg": 884,
	"./assets/thewest-digital-hero-variation-black-friday.jpg": 2958,
	"./assets/thewest-digital-hero-variation-eofy-mobile.jpg": 885,
	"./assets/thewest-digital-hero-variation-eofy.jpg": 2959,
	"./assets/thewest-digital-hero-variation-experiment2-cropped.jpg": 886,
	"./assets/thewest-digital-hero-variation-experiment2.jpg": 2960,
	"./assets/thewest-digital-hero-variation-footy-lives-here-mobile.jpg": 887,
	"./assets/thewest-digital-hero-variation-footy-lives-here.jpg": 2961,
	"./assets/thewest-digital-hero-variation-summer-of-cricket-mobile.jpg": 888,
	"./assets/thewest-digital-hero-variation-summer-of-cricket.jpg": 2962,
	"./assets/thewest-digital-hero-variation-vanishing-cousins-cropped.jpg": 889,
	"./assets/thewest-digital-hero-variation-vanishing-cousins.jpg": 2963,
	"./assets/thewest-digital-hero.jpg": 2964
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 880;